import { fetchAuthSession } from 'aws-amplify/auth';
import { consoleApiUrl } from '../../config';
import { RECORD_USER_EVENT } from './recordUserEvent.mutation';
import { RecordUserEventInput } from './userActivity.types';

/**
 * Records a user event on the centralized console GraphQL endpoint.
 *
 * Fire-and-forget telemetry: any failure (missing config, no session token,
 * network or GraphQL error) is swallowed so it can never affect the app.
 */
export async function recordUserEvent(input: RecordUserEventInput): Promise<void> {
  try {
    if (!consoleApiUrl) {
      return;
    }

    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    if (!token) {
      return;
    }

    await fetch(consoleApiUrl, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: token,
      },
      body: JSON.stringify({ query: RECORD_USER_EVENT, variables: { input } }),
    });
  } catch {
    /* ignore — user-event recording is best-effort */
  }
}
